import { useContext } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { EmailPreviewContext } from "./TourReco";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";

const EmailPreview = ({emailPreHtml, setEmailPreHtml}) => {
  const sendPreviewMailUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.sendPreviewMail}`;

  const [emailPreviewDialog, setEmailPreviewDialog] = useContext(EmailPreviewContext);

  const handleSubmit = async () => {
    const htmlData = emailPreHtml.includes("<!DOCTYPE html>")
      ? emailPreHtml
      : `<!DOCTYPE html><html><head><title>OKR Submit Notification</title></head><body>${emailPreHtml}</body></html>`;
    // const formData = new FormData();
    // formData.append('multipartFile', htmlFile);
    // const sendFile = await OAuthService.updateUploadFile(sendPreviewMailUrl, formData);
    const sendFile = await OAuthService.addData(sendPreviewMailUrl, htmlData);
    console.log('sendFile', sendFile);
  };

  return (
    <Dialog
      open={emailPreviewDialog}
      onClose={() => setEmailPreviewDialog(false)}
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle>
        <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
          <span>Email Preview</span>
          <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
            <Button onClick={() => setEmailPreviewDialog(false)}>
              <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
            </Button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-description">
          <div className="mb-16 flex justify-end">
            <Button
              variant="contained"
              color="warning"
              onClick={() => handleSubmit()}
            >
              Send
            </Button>
          </div>
          <div className="App text-black">
            <CKEditor
              editor={ClassicEditor}
              /* config={editorConfiguration} */
              data={emailPreHtml}
              // onInit={(editor) => {
              //   console.log("Editor is ready to use!", editor);
              // }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setEmailPreHtml(data);
              }}
            />
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default EmailPreview;
